<template>
  <div class="xcard">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h3 class="text-primary text-center mt-0 pt-0 mb-1">
      ASIGNACION DE ESTUDIANTES POR PROGRAMA....
    </h3>

    <v-row dense> 

      <v-col cols="12" sm="6" md="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Seleccione la fecha:"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              hide-details
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field v-model.number="xcuota" label="Cuota:" type="number" dense outlined hide-details />
      </v-col> 
      <v-col cols="12" sm="2" md="3">
        <v-btn class="blue darken-2" dark tile :disabled="loadingprograms || loading" @click="listarsignaciones()">
          Calcular
        </v-btn>
      </v-col>
    </v-row>

    <div v-if="filtros.programa">
      <v-alert dense outlined type="info">
        <small class="red--text">
          Tomar en cuenta la fecha de inicio del programa para poder ver correctamente los datos
        </small>
        <p class="mb-0"><b>Fecha inicio del programa:</b> {{ filtros.programa.fecha_inicio }}</p>
        <p class="mb-0"><b>Fecha de finalizacion:</b> {{ filtros.programa.fecha_fin }}</p>
      </v-alert>
    </div>

    <v-progress-linear indeterminate v-if="loading" class="mt-2" />

    <div><AAsignacionTabla1 ref="asignacionestabla1" v-on:dataloaded="dataloaded" /></div>
    <p class="text-center text-danger">
      <b>{{ msg }}</b>
    </p>
  </div>
</template>

<script>
  import AAsignacionTabla1 from '@/components/AAsignacionProgV3.vue';
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';

  export default {
    data() {
      return {
        islinktoviewdirectasig: false,
        gestiones: [2024,2023, 2022, 2021, 2020, 2019, 2018, 2017],
        meses: [
          { id: 1, text: 'Enero' },
          { id: 2, text: 'Febrero' },
          { id: 3, text: 'Marzo' },
          { id: 4, text: 'Abril' },
          { id: 5, text: 'Mayo' },
          { id: 6, text: 'Junio' },
          { id: 7, text: 'Julio' },
          { id: 8, text: 'Agosto' },
          { id: 9, text: 'Septiembre' },
          { id: 10, text: 'Octubre' },
          { id: 11, text: 'Noviembre' },
          { id: 12, text: 'Diciembre' },
        ],
        tiposasignacion: [
          { id: 1, text: 'Asignacion' },
          { id: 2, text: 'Inscritos' },
        ],
        programas: [],
        plataformas: [],
        loadinggestion: false,
        loadingprograms: false,
        loadingmes: false,
        filtros: {
          gestion: null,
          gestionasig: null,
          programa: null,
          mes: null,
          tipoasignacion: null,
        },
        buscar: '',
        datos: [],
        loading: false,
        msg: '',
        omit_filtro: false,

        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        menu2: false,
        xcuota: 1,
        only_cuota: true,
      };
    },
    watch: {
      'filtros.gestion': function() {
        this.resetasignaciones();
        if (this.filtros.gestion) this.listarprogramasgraphql();
      },
      /*'filtros.gestionasig': function() {
        if (this.filtros.gestionasig) this.listarsignaciones();
      },
      'filtros.mes': function() {
        if (this.filtros.mes) this.listarsignaciones();
      },
      'filtros.programa': function() {
        if (this.filtros.programa) this.listarsignaciones();
      },*/
      'filtros.tipoasignacion': function() {
        if (this.filtros.tipoasignacion) this.setipoasignacion();
      },
      '$store.state.CARGO.sede': function() {
        this.resetasignaciones();
        this.listarprogramasgraphql();
      },
      '$store.state.convenio': function() {
        if (this.$store.state.convenio) {
          this.listarprogramasgraphql();
        }
      },
      omit_filtro: function() {
        this.listarprogramasgraphql();
      },
      date: function() {
        // this.validarNoFechaFutura();
      },
      /* xcuota: function() {
        if (this.filtros.gestionasig) this.listarsignaciones();
      },
      date: function() {
        if (this.filtros.gestionasig) this.listarsignaciones();
      }, */
    },
    components: { AAsignacionTabla1 },
    methods: {
      async listarprogramasgraphql() {
        /*this.loadingprograms = true;
        this.loadingmodulos = true;
        this.programas = [];
        this.filtros.programa = null;
        let idsede = this.$store.state.CARGO.sede.id;
        const vue = this;
        var sql = gql`query{ getProgramas(cursor:1000000,estado:true,idsede:${idsede}, gestion:${this.filtros.gestion}){ id,fase,version,grupo,estado,fecha_inicio,fecha_fin,codigo,nombre_compuesto,universidad{id,nombre},postgrado{categoria{id}},plataforma_id} getPlataformas(estado: true) { id nombre direccion unidad_negocio_id estado } }`;
        await this.$apollo
          .query({ query: sql, variables: { cursor: this.cursor } })
          .then(({ data }) => {
            let datos = data.getProgramas;
            if (this.$store.state.convenio && !this.omit_filtro) {
              datos = datos.filter((x) => {
                let convenio = vue.$store.state.convenio.id;
                if (!x.universidad) x.universidad = { id: convenio };
                let universidad = x.universidad.id;
                return convenio == universidad;
              });
            }

            vue.plataformas = data.getPlataformas;
            datos.forEach((x, indice) => {
              if (!x.codigo) x.text = `${indice + 1}.- ${x.nombre_compuesto}`;
              else x.text = `${indice + 1}.- ${x.nombre_compuesto} [${x.codigo}]`;
              x.value = x.id;
              let iscurso = x.postgrado.categoria.id == 500; // curso id = 5
              if (!iscurso) vue.programas.push(x);
            });
            if (vue.filtros.programa) {
              let existe = vue.programas.find((x) => x.id == vue.filtros.programa.id);
              if (!existe) vue.programas.push(vue.filtros.programa);
            }
            window.console.log(datos);
            vue.loadingprograms = false;
            vue.loadingmodulos = false;
          })
          .catch(() => {
            vue.loadingprograms = false;
            vue.loadingmodulos = false;
          });*/
      },
      setipoasignacion() {
        /*let tipoasignacion = this.filtros.tipoasignacion;
        this.$refs.asignacionestabla1.setipoasignacion(tipoasignacion);*/
      },
      resetasignaciones() {
        //this.$refs.asignacionestabla1.resetasignaciones();
      },
      validarNoFechaFutura() {
        let date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
        date.setHours(23);
        date.setMinutes(59);

        let date2 = new Date(this.date);
        date2.setHours(date2.getHours() + 4);

        let mayor = date2.getTime() > date.getTime();
        if (mayor) {
          let vue = this;
          let hoy = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
          const [year, month, day] = hoy.split('-');
          let txt = `${year}-${month}-${day}`;
          this.$root.$notify.show(`Fechas futuras no estan permitidas.`, { color: 'red' });
          setTimeout(() => {
            vue.date = txt;
          }, 500);
        }
      },

      listarsignaciones() {
       
        //window.console.log(this.filtros);
        let anio = this.filtros.gestionasig;
        let mes = this.filtros.mes.id;
        let tipoasignacion = this.filtros.tipoasignacion;
        if (this.loading) return; // puede dar error si no se reseat la variable
        const sedeid = this.$store.state.CARGO.sede.id;

        this.loading = true;
        this.$refs.asignacionestabla1.obtenerasignaciones(
          anio,
          mes,
          {},
          tipoasignacion,
          {},
          this.xcuota,
          this.date,
          this.only_cuota,
          sedeid,
        );
      },
      dataloaded() {
        this.loading = false;
      },
      defaultdata() {
        let date = new Date();
        let anio = date.getFullYear();
        let mes = date.getMonth() + 1;
        this.filtros.gestion = '' + anio;
        this.filtros.gestionasig = '' + anio;
        this.filtros.tipoasignacion = this.tiposasignacion[0];
        this.filtros.mes = this.meses.find((x) => x.id == mes);
      },
      getOnlyPlataformas(idprograma) {
        const vue = this;
        var sql = gql`
          query {
            getPlataformas(estado: true) {
              id
              nombre
              direccion
              unidad_negocio_id
              estado
            }
          }
        `;
        this.$apollo
          .query({ query: sql, variables: { cursor: this.cursor } })
          .then(({ data }) => {
            vue.plataformas = data.getPlataformas;
            vue.getProgramaData(idprograma);
          })
          .catch(() => {});
      },
      getProgramaData(id) {
        let vue = this;
        xaxios
          .get(`${process.env.VUE_APP_API_REST}/esam/programa/id/${id}`)
          .then(async ({ data }) => {
            //window.console.log('PROGRMA GET:::', data);
            vue.filtros.programa.plataforma_id = data.plataforma_id;
            vue.listarsignaciones();
          })
          .catch(() => {});
      },
    },
    mounted() {
      this.defaultdata();
      /*let p = this.$route.params;
      let idprograma = this.$route.query.idprograma;
      if (p && p.programa_id) {
        this.islinktoviewdirectasig = true;
        window.console.log('islinktoviewdirectasig:', p);
        //this.filtros.gestion = p.xgestion;
        this.filtros.gestionasig = p.xgestion;
        this.filtros.mes = this.meses.find((x) => x.id == p.xmes);
        this.filtros.tipoasignacion = this.tiposasignacion[0];
        this.filtros.programa = { id: p.programa_id, text: p.programa_nombre, plataforma_id: null };
        this.getOnlyPlataformas(p.programa_id);
        //this.getProgramaData(p.programa_id);
        //this.listarsignaciones();
      } else if (idprograma) {
        let name = this.$route.query.name;
        this.islinktoviewdirectasig = true;
        this.filtros.programa = { id: idprograma, text: name, nombre_compuesto: name, plataforma_id: null };
        this.filtros.gestionasig = 1;
        this.filtros.mes = 1;
        this.filtros.tipoasignacion = 1;
        this.listarsignaciones();
      } else {
        this.defaultdata();
        this.listarsignaciones();
      }
      window.console.log('PRAMS: ', this.$route.params);
      window.console.log(this.$router.params);*/
    },
  };
</script>
